import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { Block } from "./models/Block";
import { Plot, PlotGroup } from './models/Plot';

export default class GlobalStateVuexModule extends AbacoVuexModule {
    @State() curBlock!: Block | null;
    @State() curPlot!: Plot | null;
    @State() curPlotGroup!: PlotGroup | null;
    @State({ default: [] }) plots!: Plot[];
    @State() plotSelectionNavBarOpen!: boolean;
    @State() plotGroupSelectionNavBarOpen!: boolean;
    @State() plotCount!: number;
    @State() coord!: number[];
    @State({ default: false }) isSatelliteIndexWidgetVisible!: boolean;
}
